import React, { useEffect, useState } from 'react';
import './ProductsPage.css';
import './HomePage.css';

const ProductsPage = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const animatedElements = document.querySelectorAll('[data-animate]');
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -5% 0px'
      }
    );

    animatedElements.forEach(el => observer.observe(el));

    return () => {
      animatedElements.forEach(el => observer.unobserve(el));
      observer.disconnect();
    };
  }, []);

  return (
    <div className="products-page">
      {/* Header */}
      <header className="header">
        <a href="/" className="header-logo-link">
          <span className="header-logo-group">
            <img
              src="/assets/brand/WarmCore Logo Eng.svg"
              alt="WarmCore"
              className="header-logo header-logo-eng"
            />
            <img
              src="/assets/brand/WarmCore Title CHN.svg"
              alt="暖芯科技"
              className="header-logo header-logo-chn"
            />
          </span>
        </a>
        <nav className="header-nav">
          <a href="/gmet-tech" className="nav-link">
            <span className="nav-link-bold gmet-trademark">GMET</span>®技术
          </a>
          <a href="/products" className="nav-link">解决方案与产品</a>
          <a href="/about" className="nav-link">关于我们</a>
        </nav>
        <button
          className="header-menu-button"
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={isMobileMenuOpen}
          onClick={() => setIsMobileMenuOpen(prev => !prev)}
        >
          <span className={`header-menu-line ${isMobileMenuOpen ? 'is-open' : ''}`}></span>
          <span className={`header-menu-line ${isMobileMenuOpen ? 'is-open' : ''}`}></span>
          <span className={`header-menu-line ${isMobileMenuOpen ? 'is-open' : ''}`}></span>
        </button>
      </header>
      {isMobileMenuOpen && (
        <div className="header-mobile-menu">
          <a
            href="/gmet-tech"
            className="header-mobile-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <span className="nav-link-bold gmet-trademark">GMET</span>®技术
          </a>
          <a
            href="/products"
            className="header-mobile-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            解决方案与产品
          </a>
          <a
            href="/about"
            className="header-mobile-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            关于我们
          </a>
        </div>
      )}

      {/* Main Content Container */}
      <div className="products-content-wrapper">
        {/* Hero + First Grid Section */}
        <section className="hero-and-grid-section">
          {/* Hero Image on Left */}
          <div className="hero-product-container">
            <img
              src="https://api.builder.io/api/v1/image/assets/TEMP/a5bb610016f43df25a45822323da26d589ff44c3?width=1428"
              alt="智能深睡毯 Lite"
              className="hero-product-img"
            />
            <div className="hero-text-overlay">
              <h1 className="hero-overlay-title">智能深睡毯 Lite</h1>
              <p className="hero-overlay-subtitle">了解详情</p>
            </div>
          </div>

          {/* First Product Grid 2x2 on Right */}
          <div className="first-product-grid">
            {/* Row 1 */}
            <div className="grid-item">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/40d67ea392d99cd2f1461772137210bcd6a4f53d?width=559"
                alt="汽车客舱热源解决方案"
                className="grid-item-img"
              />
              <h3 className="grid-item-title">汽车客舱热源解决方案</h3>
              <ul className="grid-item-list">
                <li>GMET®技术为核心驱动力</li>
                <li>轻量级，静音性</li>
                <li>新能源</li>
                <li>适用新能源车的座舱加热解决方案</li>
              </ul>
            </div>

            <div className="grid-item grid-item-offset">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/ba9164746453e351684ad2b9fffff4b2f1844960?width=557"
                alt="智能深睡毯Lite"
                className="grid-item-img"
              />
              <h3 className="grid-item-title">智能深睡毯Lite</h3>
              <ul className="grid-item-list">
                <li>Powered by GMET®</li>
                <li>快速升温，精准调节</li>
                <li>更低能耗</li>
                <li>远超同类发热产品的耐疲劳性</li>
              </ul>
            </div>

            {/* Row 2 */}
            <div className="grid-item">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/ba9164746453e351684ad2b9fffff4b2f1844960?width=557"
                alt="智能护膝"
                className="grid-item-img"
              />
              <h3 className="grid-item-title">智能护膝</h3>
              <ul className="grid-item-list">
                <li>Powered by GMET®</li>
                <li>自适应仿生支护</li>
                <li>精准控温</li>
                <li>适配充电宝</li>
              </ul>
            </div>

            <div className="grid-item">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/8b06eee54e2042ddc8f6234dbefb97c78d74e8e3?width=557"
                alt="智能深睡毯pro3.0"
                className="grid-item-img"
              />
              <h3 className="grid-item-title">智能深睡毯pro3.0</h3>
              <ul className="grid-item-list">
                <li>Powered by GMET®</li>
                <li>智能调温算法</li>
                <li>手机App记录睡眠监测</li>
                <li>分区控温，无感唤醒</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Divider Image */}
        <section className="product-divider">
          <img
            src="/assets/carpet.png"
            alt="智能深睡毯 Pro3.0"
            className="product-divider-image"
          />
          <div className="product-divider-overlay">
            <span className="product-divider-title">智能深睡毯Pro3.0</span>
            <span className="product-divider-link">了解详情</span>
          </div>
        </section>

        {/* Second Product Grid 1x4 */}
        <section className="second-product-grid-section">
          <div className="second-product-grid">
            <div className="horizontal-item">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/ba9164746453e351684ad2b9fffff4b2f1844960?width=557"
                alt="智能护膝"
                className="horizontal-item-img"
              />
              <h3 className="horizontal-item-title">智能护膝</h3>
              <ul className="horizontal-item-list">
                <li>Powered by GMET®</li>
                <li>自适应仿生支护</li>
                <li>精准控温</li>
                <li>适配充电宝</li>
              </ul>
            </div>

            <div className="horizontal-item">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/40d67ea392d99cd2f1461772137210bcd6a4f53d?width=559"
                alt="汽车客舱热源解决方案"
                className="horizontal-item-img"
              />
              <h3 className="horizontal-item-title">汽车客舱热源解决方案</h3>
              <ul className="horizontal-item-list">
                <li>GMET®技术为核心驱动力</li>
                <li>轻量级，静音性</li>
                <li>新能源</li>
                <li>适用新能源车的座舱加热解决方案</li>
              </ul>
            </div>

            <div className="horizontal-item">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/8b06eee54e2042ddc8f6234dbefb97c78d74e8e3?width=557"
                alt="智能深睡毯pro3.0"
                className="horizontal-item-img"
              />
              <h3 className="horizontal-item-title">智能深睡毯pro3.0</h3>
              <ul className="horizontal-item-list">
                <li>Powered by GMET®</li>
                <li>智能调温算法</li>
                <li>手机App记录睡眠监测</li>
                <li>分区控温，无感唤醒</li>
              </ul>
            </div>

            <div className="horizontal-item">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/ba9164746453e351684ad2b9fffff4b2f1844960?width=557"
                alt="智能深睡毯Lite"
                className="horizontal-item-img"
              />
              <h3 className="horizontal-item-title">智能深睡毯Lite</h3>
              <ul className="horizontal-item-list">
                <li>Powered by GMET®</li>
                <li>精准控温，均匀温场</li>
                <li>分区控温</li>
                <li>低压直流供电</li>
              </ul>
            </div>
          </div>
        </section>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-divider"></div>

        <div className="footer-content">
          <div className="footer-newsletter">
            <div className="footer-brand-logos">
              <img
                src="/assets/brand/WarmCore Logo Eng.svg"
                alt="WarmCore"
                className="footer-brand-logo footer-brand-logo-eng"
              />
            </div>
            <div className="footer-newsletter-input">
              <p className="footer-newsletter-title">
                希望获取更多咨询？
                <br />
                留下您的邮箱
              </p>
              <div className="footer-newsletter-field">
                <span className="footer-newsletter-placeholder">输入电子邮件</span>
                <span className="footer-newsletter-underline" />
                <img
                  src="/assets/Arrow.svg"
                  alt=""
                  aria-hidden="true"
                  className="footer-email-arrow"
                />
              </div>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h3 className="footer-column-title">关于公司</h3>
              <ul className="footer-column-links">
                <li><a href="/gmet-tech">技术创新</a></li>
                <li><a href="/about">关于我们</a></li>
                <li><a href="#contact">联系我们</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-column-title">服务支持</h3>
              <ul className="footer-column-links">
                <li><a href="#partnership">企业合作</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-column-title">产品</h3>
              <ul className="footer-column-links">
                <li><a href="/products">解决方案与产品</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-language-selector">
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/b5713774f00b3eb06583559e2886eddbd5835929?width=24"
            alt="Language"
            className="footer-language-icon"
          />
          <span className="footer-language-text">ENG</span>
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/cfc9047dc43436e605a5762b2ab61e04ed7c4aa9?width=16"
            alt="Dropdown"
            className="footer-language-arrow"
          />
        </div>

        <p className="footer-copyright">北京暖芯科技有限公司</p>
      </footer>
    </div>
  );
};

export default ProductsPage;
